// MultiStepForm.js
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Container,
  Form,
  Button,
  ProgressBar,
  Nav,
  Alert,
} from "react-bootstrap";
import SignaturePad from "react-signature-canvas"; // Import the SignaturePad component
import "./Signature.css";
import { getSasToken } from "../../store/thunk/user";
import { connect } from "react-redux";
import { updateForm } from "../../utils/updateForm";
import { uploadDocumentAndGetUrl } from "../../utils/uploadDocument";
import { dataURLtoBlob } from "../../utils/dataURLtoBlob";
import { toast } from "react-toastify";
import { triggerButtonClick } from "../../utils/triggerLibraryButton";
import WorkExperienceDownload from "./Download/WorkExperienceDownload";
import Add from "@mui/icons-material/Add";
import { saveAs } from "file-saver";

const WorkExperience = ({
  currentDocument,
  documentList,
  user,
  sasToken,
  ipAddress,
  getSasToken,
}) => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(0); // Progress percentage for each step
  const [formData, setFormData] = useState({
    companyName1: "",
    contactName1: "",
    address1: "",
    postcode1: "",
    email1: "",
    telephone1: "",
    dateOfEmployment1: "",
    wishApproached1: false,
    companyName2: "",
    contactName2: "",
    address2: "",
    postcode2: "",
    email2: "",
    telephone2: "",
    dateOfEmployment2: "",
    wishApproached2: false,
    consent: false,
    previousEmploymentHistory: null,
    schoolUniversityHistory: null,
    signature: "", // Store the signature data as a string
  });
  const [errors, setErrors] = useState({});
  const sigPadRef = useRef(null); // Reference to the SignaturePad component
  useEffect(() => {
    setFormData(currentDocument);
    if (currentDocument?.step) {
      setStep(currentDocument?.step);
    }
    if (currentDocument?.progress) {
      setProgress(currentDocument?.progress);
    }
    if (currentDocument?.progress === 100) {
      getSasToken();
    }
  }, [currentDocument]);
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  // Function to validate each step
  const validateStep = () => {
    let formErrors = {};
    if (step === 1) {
      if (!formData.companyName1)
        formErrors.companyName1 = "This is a required field";
      if (!formData.contactName1)
        formErrors.contactName1 = "This is a required field";
      if (!formData.address1) formErrors.address1 = "This is a required field";
      if (!formData.postcode1)
        formErrors.postcode1 = "This is a required field";
      if (!formData.email1) formErrors.email1 = "This is a required field";
      if (!formData.telephone1)
        formErrors.telephone1 = "This is a required field";

      if (!formData.companyName2)
        formErrors.companyName2 = "This is a required field";
      if (!formData.contactName2)
        formErrors.contactName2 = "This is a required field";
      if (!formData.address2) formErrors.address2 = "This is a required field";
      if (!formData.postcode2)
        formErrors.postcode2 = "This is a required field";
      if (!formData.email2) formErrors.email2 = "This is a required field";
      if (!formData.telephone2)
        formErrors.telephone2 = "This is a required field";
    } else if (step === 2) {
      if (!formData.consent) formErrors.consent = "You must agree to the terms";
      if (sigPadRef.current.isEmpty())
        formErrors.signature = "Signature is required"; // Check if the signature pad is empty
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Function to go to the next step
  const nextStep = async () => {
    if (validateStep()) {
      let documentUrl = "";
      let documentUrl2 = "";
      console.log("formData?.previousEmploymentHistory", formData?.previousEmploymentHistory);
      if(formData?.previousEmploymentHistory) {
        const formDataSign = new FormData();
        // Append the Blob as a file to the FormData
        // The second argument is the file name, which you can customize as needed
        formDataSign.append(
          "file",
          formData?.previousEmploymentHistory,
          formData?.previousEmploymentHistory?.name,
        );
        // Send the FormData using postMultiPartFormData
        documentUrl =
            (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      }
      
      if(formData?.schoolUniversityHistory) {
        const formDataSign2 = new FormData();
        formDataSign2.append(
          "file",
          formData?.schoolUniversityHistory,
          formData?.schoolUniversityHistory?.name
        );
        // Send the FormData using postMultiPartFormData
        documentUrl2 =
            (await uploadDocumentAndGetUrl(formDataSign2, user?.token)) || "";
      }
      let  previousEmploymentHistoryData = null;
      if(documentUrl) {
        previousEmploymentHistoryData = {
          url: documentUrl,
          name: formData?.previousEmploymentHistory?.name,
        }
      }
      let schoolUniversityHistoryData = null;
      if(documentUrl2) {
        schoolUniversityHistoryData = {
          url: documentUrl2,
          name: formData?.schoolUniversityHistory?.name,
        }
      }
      const payload = {
        [currentDocument["key"]]: {
          name: currentDocument?.name,
          ...formData,
          progress: progress + 50,
          step: step + 1,
          previousEmploymentHistory: previousEmploymentHistoryData,
          schoolUniversityHistory: schoolUniversityHistoryData,
        },
      };
      setFormData({
        ...formData,
        schoolUniversityHistory: schoolUniversityHistoryData,
        previousEmploymentHistory: previousEmploymentHistoryData,
      });
      updateForm(payload, documentList, user);
      setStep(step + 1);
      setProgress(progress + 50);
    }
  };

  // Function to go to the previous step
  const prevStep = () => {
    setStep(step - 1);
    setProgress(progress - 50);
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep()) {
      // Get the signature data as a base64 image
      const signatureImage = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormData({ ...formData, signature: signatureImage });
      const signatureBlob = dataURLtoBlob(signatureImage);
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append(
        "file",
        signatureBlob,
        `${[currentDocument["key"]]}.png`
      );
      // Send the FormData using postMultiPartFormData
      const documentUrl =
        (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            progress: 100,
            step: step,
            signature: documentUrl,
            signDate: new Date(),
            ipAddress: ipAddress,
          },
        };
        updateForm(payload, documentList, user);
        toast.success("Successfully filled the form.");
        triggerButtonClick();
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
      // Additional submit logic here, such as sending formData to the server
    }
  };
  // Clear the signature pad
  const clearSignature = () => {
    sigPadRef.current.clear();
    setFormData({ ...formData, signature: "" });
  };
  // Function to handle file removal
  const handleFileRemove = (name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: null,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  };
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0], // Store the selected file
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null })); // Clear error on file change
  };
  return (
    <Container className="mt-5">
      {currentDocument?.progress === 100 ? (
        <>
          <WorkExperienceDownload user={documentList?.userDetail} data={currentDocument} sasToken={sasToken} />
          <div className="container mt-2">
            <h2>References</h2>
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between">
                Reference 1
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Company Name & Your Job Title</strong>{" "}
                <span>{currentDocument?.companyName1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Contact Name</strong>{" "}
                <span>{currentDocument?.contactName1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Address</strong>{" "}
                <span>{currentDocument?.address1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Postcode</strong>{" "}
                <span>{currentDocument?.postcode1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Email</strong>{" "}
                <span>{currentDocument?.email1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Date of Employment</strong>{" "}
                <span>{currentDocument?.dateOfEmployment1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>
                  - Please tick if you wish to be approached before this person
                  is contacted.
                </strong>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                Reference 2
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Company Name & Your Job Title</strong>{" "}
                <span>{currentDocument?.companyName2 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Contact Name</strong>{" "}
                <span>{currentDocument?.contactName2 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Address</strong>{" "}
                <span>{currentDocument?.address2 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Postcode</strong>{" "}
                <span>{currentDocument?.postcode2 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Email</strong>{" "}
                <span>{currentDocument?.email1 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>Date of Employment</strong>{" "}
                <span>{currentDocument?.dateOfEmployment2 || "--"}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <strong>
                  - Please tick if you wish to be approached before this person
                  is contacted.
                </strong>
              </li>
            </ul>
            <h2>Uploaded Proofs</h2>
            <ul className="list-group">
              <li className="list-group-item d-flex justify-content-between align-items-center">
                School/University History
                {currentDocument?.schoolUniversityHistory?.url ? (
                  <button
                    onClick={() => {
                      const fileUrlWithSas = `${currentDocument?.schoolUniversityHistory?.url}?${sasToken}`;
                      const fileName =
                        currentDocument?.schoolUniversityHistory?.name;

                      // Fetch the file with the appended SAS token
                      fetch(fileUrlWithSas)
                        .then((response) => {
                          if (!response.ok) {
                            throw new Error("Network response was not ok");
                          }
                          return response.blob(); // Convert response to blob
                        })
                        .then((blob) => {
                          saveAs(blob, fileName); // Download the file using file-saver
                        })
                        .catch((error) => {
                          console.error(
                            "Error downloading file with SAS token:",
                            error
                          );
                        });
                    }}
                    className="btn btn-primary text-white"
                  >
                    Download
                  </button>
                ) : (
                  <button
                    disabled
                    className="btn btn-dark text-white btn-disabled"
                  >
                    {" "}
                    Not Available
                  </button>
                )}
              </li>
              <li className="list-group-item d-flex justify-content-between align-items-center">
                CV / Previous Employment Proof
                {currentDocument?.previousEmploymentHistory?.url ? (
                  <button
                    onClick={() => {
                      const fileUrlWithSas = `${currentDocument?.previousEmploymentHistory?.url}?${sasToken}`;
                      const fileName =
                        currentDocument?.previousEmploymentHistory?.name;

                      // Fetch the file with the appended SAS token
                      fetch(fileUrlWithSas)
                        .then((response) => {
                          if (!response.ok) {
                            throw new Error("Network response was not ok");
                          }
                          return response.blob(); // Convert response to blob
                        })
                        .then((blob) => {
                          saveAs(blob, fileName); // Download the file using file-saver
                        })
                        .catch((error) => {
                          console.error(
                            "Error downloading file with SAS token:",
                            error
                          );
                        });
                    }}
                    className="btn btn-primary text-white"
                  >
                    Download
                  </button>
                ) : (
                  <button
                    disabled
                    className="btn btn-dark text-white btn-disabled"
                  >
                    {" "}
                    Not Available
                  </button>
                )}
              </li>
              <li className="list-group-item">
                <div className="row">
                  {/* Text column */}
                  <div className="col-6 d-flex align-items-center">
                    I certify that all documents and scans uploaded belong to
                    myself and are a true reflection of my identity.
                  </div>

                  {/* Image column */}
                  <div className="col-6 text-end">
                    {currentDocument?.signature && (
                      <img
                        width={100}
                        src={`${currentDocument?.signature}?${sasToken}`}
                        alt="Signature"
                      />
                    )}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </>
      ) : (
        <>
          <Nav variant="pills" className="justify-content-center mb-3">
            <Nav.Item>
              <Nav.Link
                className={step === 1 ? "text-light" : ""}
                active={step === 1}
              >
                Step 1
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={step === 2 ? "text-light" : ""}
                active={step === 2}
              >
                Step 2
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <ProgressBar now={progress} className="mb-4" />

          <Form onSubmit={handleSubmit}>
            {step === 1 && (
              <div>
                <h3>Section 1: References</h3>
                <h4>Reference 1</h4>
                <Form.Group className="mb-3">
                  <Form.Label>Company Name & Your Job Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName1"
                    value={formData.companyName1}
                    onChange={handleChange}
                    isInvalid={!!errors.companyName1}
                    required
                  />
                  {errors.companyName1 && (
                    <Alert variant="danger">{errors.companyName1}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Contact Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="contactName1"
                    value={formData.contactName1}
                    onChange={handleChange}
                    isInvalid={!!errors.contactName1}
                    required
                  />
                  {errors.contactName1 && (
                    <Alert variant="danger">{errors.contactName1}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="address1"
                    value={formData.address1}
                    onChange={handleChange}
                    isInvalid={!!errors.address1}
                    required
                  />
                  {errors.address1 && (
                    <Alert variant="danger">{errors.address1}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Postcode</Form.Label>
                  <Form.Control
                    type="text"
                    name="postcode1"
                    value={formData.postcode1}
                    onChange={handleChange}
                    isInvalid={!!errors.postcode1}
                    required
                  />
                  {errors.postcode1 && (
                    <Alert variant="danger">{errors.postcode1}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    name="email1"
                    value={formData.email1}
                    onChange={handleChange}
                    isInvalid={!!errors.email1}
                    required
                  />
                  {errors.email1 && (
                    <Alert variant="danger">{errors.email1}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Telephone</Form.Label>
                  <Form.Control
                    type="text"
                    name="telephone1"
                    value={formData.telephone1}
                    onChange={handleChange}
                    isInvalid={!!errors.telephone1}
                    required
                  />
                  {errors.telephone1 && (
                    <Alert variant="danger">{errors.telephone1}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Employment</Form.Label>
                  <Form.Control
                    type="text"
                    name="dateOfEmployment1"
                    value={formData.dateOfEmployment1}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="wishApproached1"
                    label="Please tick if you wish to be approached before this person is contacted."
                    checked={formData.wishApproached1} // Use checked for checkboxes
                    onChange={handleChange}
                  />
                </Form.Group>
                <h4>Reference 2</h4>
                <Form.Group className="mb-3">
                  <Form.Label>Company Name & Your Job Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName2"
                    value={formData.companyName2}
                    onChange={handleChange}
                    isInvalid={!!errors.companyName2}
                    required
                  />
                  {errors.companyName2 && (
                    <Alert variant="danger">{errors.companyName2}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Contact Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="contactName2"
                    value={formData.contactName2}
                    onChange={handleChange}
                    isInvalid={!!errors.contactName2}
                    required
                  />
                  {errors.contactName2 && (
                    <Alert variant="danger">{errors.contactName2}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="address2"
                    value={formData.address2}
                    onChange={handleChange}
                    isInvalid={!!errors.address2}
                    required
                  />
                  {errors.address2 && (
                    <Alert variant="danger">{errors.address2}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Postcode</Form.Label>
                  <Form.Control
                    type="text"
                    name="postcode2"
                    value={formData.postcode2}
                    onChange={handleChange}
                    isInvalid={!!errors.postcode2}
                    required
                  />
                  {errors.postcode2 && (
                    <Alert variant="danger">{errors.postcode2}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    name="email2"
                    value={formData.email2}
                    onChange={handleChange}
                    isInvalid={!!errors.email2}
                    required
                  />
                  {errors.email2 && (
                    <Alert variant="danger">{errors.email2}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Telephone</Form.Label>
                  <Form.Control
                    type="text"
                    name="telephone2"
                    value={formData.telephone2}
                    onChange={handleChange}
                    isInvalid={!!errors.telephone2}
                    required
                  />
                  {errors.telephone2 && (
                    <Alert variant="danger">{errors.telephone2}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Employment</Form.Label>
                  <Form.Control
                    type="text"
                    name="dateOfEmployment2"
                    value={formData.dateOfEmployment2}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="wishApproached2"
                    label="Please tick if you wish to be approached before this person is contacted."
                    checked={formData.wishApproached2} // Use checked for checkboxes
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>CV / Previous Employment History</Form.Label>
                  <div className="d-flex align-items-center">
                    {formData.previousEmploymentHistory ? (
                      <div className="d-flex flex-column w-100">
                        <span className="text-success">
                          {formData.previousEmploymentHistory.name}
                        </span>
                        <Button
                          variant="danger"
                          className="mt-2"
                          onClick={() =>
                            handleFileRemove("previousEmploymentHistory")
                          }
                        >
                          Remove
                        </Button>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          id="previousEmploymentHistory"
                          name="previousEmploymentHistory"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <Button
                          className="w-100 bg-success text-white"
                          onClick={() =>
                            document
                              .getElementById("previousEmploymentHistory")
                              .click()
                          }
                        >
                          <Add /> Select File
                        </Button>
                      </>
                    )}
                  </div>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>School/University History</Form.Label>
                  <div className="d-flex align-items-center">
                    {formData.schoolUniversityHistory ? (
                      <div className="d-flex flex-column w-100">
                        <span className="text-success">
                          {formData.schoolUniversityHistory.name}
                        </span>
                        <Button
                          variant="danger"
                          className="mt-2"
                          onClick={() =>
                            handleFileRemove("schoolUniversityHistory")
                          }
                        >
                          Remove
                        </Button>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          id="schoolUniversityHistory"
                          name="schoolUniversityHistory"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <Button
                          className="w-100 bg-success text-white"
                          onClick={() =>
                            document
                              .getElementById("schoolUniversityHistory")
                              .click()
                          }
                        >
                          <Add /> Select File
                        </Button>
                      </>
                    )}
                  </div>
                </Form.Group>

                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              </div>
            )}

            {step === 2 && (
              <div>
                <h3>Step 2: Sign and Submit</h3>
                <p>
                  By signing this page, I confirm that I fully understand the
                  content and agree to adhere to it at all times. I also agree
                  that all the details provided in this document are accurate
                  and complete to the best of my knowledge.
                </p>
                <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={sigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.signature && (
                    <Alert variant="danger">{errors.signature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="consent"
                    label="Clear By ticking this box I consent to the company processing my
                data and the evidence of this document being stored within their
                system for the purpose of work finding services."
                    checked={formData.consent} // Use checked for checkboxes
                    onChange={handleChange}
                    isInvalid={!!errors.consent}
                  />
                  {errors.consent && (
                    <Alert variant="danger">{errors.consent}</Alert>
                  )}
                </Form.Group>
                <Button variant="secondary" onClick={prevStep} className="me-2">
                  Previous
                </Button>
                <Button variant="success" type="submit">
                  Submit
                </Button>
              </div>
            )}
          </Form>
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.user.currentDocument,
  documentList: state.user.documentList,
  user: state.user.loggedInUserData,
  sasToken: state.user.sasToken,
  ipAddress: state.user.ipAddress,
});
export default connect(mapStateToProps, { getSasToken })(WorkExperience);
